/* eslint-disable react/prop-types */
import { useAbility } from '@casl/react';
import React, { memo } from 'react';

import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import { AbilityContext } from '../../casl/AbilityContext';

export function TeamLink({ eventId, id, displayName, eventGroupId }) {
  const ability = useAbility(AbilityContext);
  const canViewTeam = ability.can('read', 'Team');
  if (id && canViewTeam) {
    const path = eventGroupId
      ? `/event-group/${eventGroupId}/events/${eventId}/teams/${id}`
      : `/event/${eventId}/teams/${id}`;
    return (
      <Link component={RouterLink} to={path}>
        {displayName}
      </Link>
    );
  }
  return displayName;
}

export default memo(TeamLink);
